type JSBridgeEvent = {
  type: string;
  payload?: any;
};
class JSBridge {
  private isAvailable: boolean;

  constructor() {
    this.isAvailable = typeof window !== 'undefined' && !!(window as any).flutter_inappwebview;
  }

  public openSchema(schema: string) {
    if (this.isAvailable) {
      window.location.href = schema;
    } else {
      console.warn('JSBridge is not available. Cannot open schema:', schema);
    }
  }

  public async send(event: JSBridgeEvent) {
    if (!this.isAvailable) {
      console.warn('JSBridge is not available.');
      return null;
    }
    return (window as any).flutter_inappwebview.callHandler(event.type, event.payload);
  }

  public canUseBridge() {
    return this.isAvailable;
  }

  public getVersion(): { raw: string; major: number; minor: number; patch: number } | null {
    if (!this.isAvailable) {
      return null;
    }
    const { userAgent } = window.navigator;
    // Android:
    // UA: Mozilla/5.0 (Linux; Android 13; Build/UPB1.230309.013; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/109.0.5414.123 Mobile Safari/537.36 Grab Merchant/4.132.0 (android 13; Build 224)
    // IOS:
    // UA: Mozilla/5.0 (iPad; CPU OS 18_5 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Grab Merchant/4.132.0 (ios 18.5; Build 112104211)
    const match = userAgent.match(/Grab\s+Merchant(?:\s+(?:GEA|Debug))?\/(\d+)\.(\d+)\.(\d+)/i);
    if (match) {
      const [, major, minor, patch] = match;
      return {
        raw: `${major}.${minor}.${patch}`,
        major: Number(major),
        minor: Number(minor),
        patch: Number(patch),
      };
    }
    return null;
  }

  /**
   * Get app variant from User-Agent. Distinguishes prd vs GEA vs Debug.
   * Must check more specific variants first (GEA, Debug) before generic "Grab Merchant".
   */
  public getAppVariant(): 'prd' | 'gea' | 'debug' | null {
    if (!this.isAvailable) {
      return null;
    }
    const { userAgent } = window.navigator;
    if (/Grab Merchant GEA\//i.test(userAgent)) return 'gea';
    if (/Grab Merchant Debug\//i.test(userAgent)) return 'debug';
    if (/Grab Merchant\//i.test(userAgent)) return 'prd';
    return null;
  }

  public getPlatform(): 'ios' | 'android' | null {
    if (!this.isAvailable) {
      return null;
    }
    const { userAgent } = window.navigator;
    if (/Android/i.test(userAgent)) {
      return 'android';
    }
    if (/iPhone|iPad|iPod|\bios\b/i.test(userAgent)) {
      return 'ios';
    }
    return null;
  }

  public getAppVersionFacet(): string | null {
    const version = this.getVersion();
    const platform = this.getPlatform();
    if (!version || !platform) {
      return null;
    }

    const platformFacet = platform === 'ios' ? 'ios' : 'adr';
    return `mex-${platformFacet}-${version.raw}`;
  }
}

const jsBridge = new JSBridge();

export default jsBridge;
